import React, { useMemo } from 'react'
import DocsPage from 'components/DocumentationPage'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from './messages'

const SupplierInfoPage = ({ history, match }) => {
  const { formatMessage } = useIntl()

  const docs = useMemo(() => [
    'techSpecs',
    'paymentTerms',
    'troubleshooting',
    'demoSpecs',
    'demoScript',
    'fileFormat',
    'usageTerms'
  ].map((name) => ({
    title: formatMessage(messages[`${name}Title`]),
    body: formatMessage(messages[`${name}Body`])
  })))

  return (
    <DocsPage
      loading={false}
      docs={docs}
      title={<FormattedMessage {...messages.title} />}
      subtitle={<FormattedMessage {...messages.subtitle} />}
      match={match}
    />
  )
}

export default SupplierInfoPage
